import { FolderOpen } from 'lucide-react'
import { cn } from '#/lib/utils'

interface NoDataProps {
  title?: string
  description?: string
  className?: string
  icon?: React.ElementType
  action?: { label: string; onClick: () => void }
}

export default function NoData({
  title = 'No items found',
  description = 'There are no records to display at the moment.',
  className,
  icon: Icon = FolderOpen,
  action,
}: NoDataProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8 text-center rounded-2xl border border-dashed border-neutral-300 bg-neutral-50/50 my-6 w-full',
        className,
      )}
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-3">
        <Icon className="h-7 w-7" />
      </div>
      <h4 className="text-lg font-bold text-neutral-800">{title}</h4>
      <p className="text-sm text-neutral-500 max-w-sm mt-1">{description}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="mt-4 rounded-lg border border-primary-400 px-4 py-1.5 text-sm font-semibold text-primary-700 hover:bg-primary-50 transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
